module.exports = __webpack_public_path__ + "img/fr_failure_1.d2881620.png";